const LOCALHOST_FALLBACK_PORT = '3001';
const STAGING_IP_DIRECT_API_PORT = '23001';

const normalizeUrl = (raw: string): string => raw.replace(/\/$/, '');

const isLoopbackHost = (host: string): boolean => host === 'localhost' || host === '127.0.0.1';
const isIpv4Host = (host: string): boolean => /^\d{1,3}(\.\d{1,3}){3}$/.test(host);

const mapKnownPublicHostToApi = (host: string): string | null => {
  if (host === 'timesheet.itsprodigy.com') return 'https://timesheet-api.itsprodigy.com';
  if (host === 'timesheet-staging.itsprodigy.com') return 'https://timesheet-api-staging.itsprodigy.com';
  return null;
};

export const getApiBaseUrl = (): string => {
  const envUrl = (process.env.REACT_APP_API_URL || '').trim();

  if (typeof window === 'undefined') {
    return normalizeUrl(envUrl || `http://localhost:${LOCALHOST_FALLBACK_PORT}`);
  }

  const pageHost = window.location.hostname;
  const pageProtocol = window.location.protocol || 'http:';

  const mappedApiHost = mapKnownPublicHostToApi(pageHost);
  if (mappedApiHost) return mappedApiHost;

  // If the app is opened directly from a server IP, target the published backend port
  // on the same host to bypass external proxies during staging troubleshooting.
  if (isIpv4Host(pageHost)) {
    return `${pageProtocol}//${pageHost}:${STAGING_IP_DIRECT_API_PORT}`;
  }

  if (envUrl) {
    try {
      const resolved = new URL(envUrl);

      // In local dev keep FE and BE on the same loopback host (localhost vs 127.0.0.1)
      // so SameSite cookies and browser security policies stay consistent.
      if (isLoopbackHost(pageHost) && isLoopbackHost(resolved.hostname) && pageHost !== resolved.hostname) {
        resolved.hostname = pageHost;
        return normalizeUrl(resolved.toString());
      }

      return normalizeUrl(resolved.toString());
    } catch {
      // If the env var is malformed, fallback to host-based resolution below.
    }
  }

  if (isLoopbackHost(pageHost)) {
    return `${pageProtocol}//${pageHost}:${LOCALHOST_FALLBACK_PORT}`;
  }

  return `http://localhost:${LOCALHOST_FALLBACK_PORT}`;
};